import s from './style.css';
import Container from 'elements/container';
import Icon from 'elements/icon';
import LinkBlock from 'components/linkBlock';

const objToHash = obj =>
	Object.keys(obj)
		.map(key => `${key}=${encodeURIComponent(obj[key])}`)
		.join('&');

const Header = ({
	siteName = 'Faces of Energy',
	links = {
		'/explore-map': 'Explore map',
		'/submit-data': 'Submit data',
		'/about-the-data': 'About the data',
		'/contact': 'Contact'
	},
	url = URL,
	prefill = "If we want to close the energy access gap and achieve #SDG7, women must be involved. Visit @seforallorg and @energia_org's new interactive website that maps where organizations are supporting gender equality in sustainable energy to become #SDG7AllEqual"
}) => {
	const tweetParams = {
		url,
		text: prefill
	};

	const fbParams = {
		u: url
	};

	const linkedinParams = {
		url: `${url}?cache=${CACHEBUSTER}`,
		title: prefill,
		mini: true
	};

	const mailParams = {
		subject: siteName,
		body: `${prefill + ' – ' + url}`
	};

	const social = {
		[`https://twitter.com/share?${objToHash(tweetParams)}`]: (
			<Icon icon="twitter" title="Share on Twitter" />
		),
		[`https://www.facebook.com/sharer/sharer.php?${objToHash(fbParams)}`]: (
			<Icon icon="facebook" title="Share on Facebook" />
		),
		[`https://www.linkedin.com/shareArticle?${objToHash(linkedinParams)}`]: (
			<Icon icon="linkedin" title="Share on LinkedIn" />
		),
		[`mailto:?${objToHash(mailParams)}`]: (
			<Icon icon="mail" title="Share by email" />
		)
	};

	return (
		<header className={s.header}>
			<Container className={s.inner} size="page">
				<div>
					<h1 className={s.headerTitle}>
						<a href="/">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="256"
								height="22"
								viewBox={'0 0 256 22'}
							>
								<title>Faces of Energy</title>
								<defs>
									<linearGradient x1="-38.212%" y1="45.975%" y2="50%" id="a">
										<stop stop-color="#C3F4D8" offset="0%" />
										<stop stop-color="#39B786" offset="5.169%" />
										<stop stop-color="#3C9A8A" offset="20.425%" />
										<stop stop-color="#38808B" offset="51%" />
										<stop stop-color="#2F658B" offset="68%" />
										<stop stop-color="#1D4B8C" offset="85%" />
										<stop stop-color="#413064" offset="100%" />
									</linearGradient>
								</defs>
								<path
									d="M20.879 23.228v2.781h-8.208V35H9.647V14.75h12.096v2.781h-9.072v5.697h8.208zM36.929 35l-1.431-4.941h-6.48L27.587 35h-3.294l6.426-20.493h3.078L40.223 35h-3.294zm-2.079-7.425l-2.592-8.964-2.592 8.964h5.184zm9.435-2.7c0-6.642 2.349-10.449 8.343-10.449 2.403 0 3.78.459 4.752.864v2.889c-1.539-.621-2.727-.918-4.563-.918-3.861 0-5.427 2.619-5.427 7.614 0 4.995 1.566 7.614 5.427 7.614 1.836 0 3.024-.297 4.563-.918v2.889c-.972.405-2.349.864-4.752.864-5.994 0-8.343-3.807-8.343-10.449zm30.117-1.755v2.781h-8.424v6.318h9.288V35H62.954V14.75h12.312v2.781h-9.288v5.589h8.424zm12.945.108c4.212.567 6.669 1.512 6.669 5.643 0 3.834-2.268 6.453-7.695 6.453-2.025 0-4.617-.459-5.994-1.161v-3.024c1.107.486 3.051 1.323 5.805 1.323 3.645 0 4.725-1.485 4.725-3.402 0-2.241-.945-2.781-3.672-3.132-4.941-.621-6.858-1.944-6.858-5.643 0-2.97 1.674-5.859 7.182-5.859 2.619 0 4.455.459 5.481.972v2.943c-1.485-.648-3.321-1.053-5.319-1.053-3.159 0-4.239 1.296-4.239 3.024 0 2.187 1.242 2.565 3.915 2.916zm27.51 10.341c4.887 0 5.616-3.834 5.616-8.694 0-4.86-.729-8.694-5.616-8.694s-5.616 3.834-5.616 8.694c0 4.86.729 8.694 5.616 8.694zm0 1.701c-6.615 0-7.56-5.103-7.56-10.395s.945-10.395 7.56-10.395c6.615 0 7.56 5.103 7.56 10.395s-.945 10.395-7.56 10.395zm24.285-11.664v1.701h-8.694V35h-1.836V14.75h11.475v1.701h-9.639v7.155h8.694zm25.89-.486v2.781h-8.424v6.318h9.288V35h-12.312V14.75h12.312v2.781h-9.288v5.589h8.424zM185.861 35h-2.754l-8.802-14.391.081 14.391h-2.997V14.75h2.754l8.802 14.391-.081-14.391h2.997V35zm17.292-11.88v2.781h-8.424v6.318h9.288V35h-12.312V14.75h12.312v2.781h-9.288v5.589h8.424zm9.381 3.645V35h-3.024V14.75h6.588c5.238 0 6.912 2.349 6.912 6.021 0 2.619-.81 4.536-3.294 5.4L223.955 35h-3.537l-3.672-8.235h-4.212zm0-9.234v6.48h3.996c2.808 0 3.186-1.593 3.186-3.24 0-1.674-.378-3.24-3.186-3.24h-3.996zm24.258 17.793c-6.021 0-8.235-4.077-8.235-10.449s2.214-10.449 8.316-10.449c2.781 0 4.644.486 5.805 1.053v2.97c-1.89-.783-3.483-1.188-5.427-1.188-4.158 0-5.589 2.808-5.589 7.614 0 4.968 1.485 7.614 5.589 7.614 1.242 0 2.295-.162 2.889-.378v-5.535h-3.591v-2.727h6.615v10.233c-1.053.567-3.483 1.242-6.372 1.242zm27.984-20.574l-6.885 12.123V35h-3.078v-8.127l-6.885-12.123h3.429l4.995 9.45 4.995-9.45h3.429z"
									transform="translate(-9 -14)"
									fill="url(#a)"
									fill-rule="nonzero"
								/>
							</svg>
						</a>
					</h1>
				</div>

				<input type="checkbox" id="menu" className={s.menuToggle} />
				<div>
					<div className={s.overlay} />
					<label for="menu" className={s.hamburger}>
						<Icon icon="hamburger" size="m" title={'Open menu'} />
					</label>
					<label for="menu" className={s.hamburgerClose}>
						<Icon icon="close" size="m" title={'Close menu'} />
					</label>
					<div className={s.links}>
						<nav className={s.navLinks}>
							<LinkBlock links={links} />
						</nav>
						<LinkBlock
							links={social}
							tight
							LinkType={'a'}
							rel="noopener"
							target={'_blank'}
						/>
					</div>
				</div>
			</Container>
		</header>
	);
};

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js